<template>
<div class="tableorder">
  <Header msg="admin" />
  <!-- label for table  -->
  <!-- start  -->
  <div class="mt-5 container">
    <h1 class="text-center">Quản lý đơn</h1>
  </div>
  <!-- end -->

  <!-- start option -->
  <div class="d-flex justify-content-end container">
    <button class="btn btn-sm bg-danger text-white" @click="sent()">
      <!-- <i class="fas fa-paper-plane"></i> -->
      Gửi đơn đi nhà sách
    </button>
    <button class="btn btn-sm bg-dark text-white" @click="wait()">
      <!-- <i class="fas fa-clipboard-list"></i> -->
      Xem đơn chờ
    </button>
    <!-- <button class="btn btn-sm bg-warning text-white mr-1" @click="done()"><i class="fas fa-clipboard-check"></i></button> -->
    <button class="btn btn-sm bg-primary text-white" @click="approved()">
      <!-- <i class="fas fa-calendar-check"></i> -->
      Duyệt đơn
    </button>
    <!-- <button class="btn btn-sm bg-dark text-white" @click="toggle = !toggle"><i class="fas fa-eye"></i></button> -->
    <!-- <button class="btn btn-sm bg-primary text-white" @click="deleted()"><i class="fas fa-trash"></i></button> -->
    <!-- <button class="btn btn-sm bg-dark text-white" @click="saved()"><i class="fas fa-save"></i></button> -->
  </div>
  <!-- end -->

  <div id="table-responsive" class="container">
    <!-- start table -->
    <table class="table table-response table-bordered table-striped table-sm mx-auto">
      <tr class="bg-dark text-white table-striped">
        <th class="th-sm">@</th>
        <th class="th-sm">#</th>
        <th class="th-sm">
          <!-- Nhà sách -->
          Tình trạng đơn
          <i class="fas fa-sort"></i>
        </th>

        <th class="th-sm">
          Tên khách hàng
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Địa chỉ
          <i class="fas fa-sort"></i>
        </th>
        <th class="th-sm">
          Số điện thoại
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Số điện thoại 2
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Facebook
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Link fb
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Email
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Mã sách in
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Mã sách photo
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Mã sách tặng
          <i class="fas fa-sort"></i>
        </th>
        <th class="th-sm">
          Ghi chú
          <i class="fas fa-sort"></i>
        </th>
        <th class="th-sm">
          Ngày tạo
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">Mã đơn</th>
        <th class="th-sm">
          Mã CTV
          <i class="fas fa-sort"></i>
        </th>
        <!-- <th class="th-sm">
          Người tạo đơn
          <i class="fas fa-sort"></i>
        </th> -->
        <th v-if="toggle" class="th-sm">
          Vai trò người tạo đơn
          <i class="fas fa-sort"></i>
        </th>
        <th v-if="toggle" class="th-sm">
          Thuộc
          <i class="fas fa-sort"></i>
        </th>
        <th class="th-sm" v-if="toggle">
          Trạng thái
          <i class="fas fa-sort"></i>
        </th>
        <td class="text-center">Hành động</td>
      </tr>
      <!-- data view -->
      <tr v-for="(v, k) in partOrder" :key="k">
        <td>
          <input class="btn" type="checkbox" v-bind:value="v" v-model="checkboxed" />
        </td>
        <td>{{ k + 1 }}</td>
        <td class="short" >{{ v.homebook }}</td>
        <td class="short">{{ v.name }}</td>
        <td class="short" v-if="toggle">{{ v.address }}</td>
        <td class="short">{{ v.phone_1 }}</td>
        <td class="short" v-if="toggle">{{ v.phone_2 }}</td>
        <td class="short" v-if="toggle">{{ v.fb }}</td>
        <td class="short" v-if="toggle">{{ v.link }}</td>
        <td class="short" v-if="toggle">{{ v.email }}</td>
        <td class="short" v-if="toggle">{{ v.print }}</td>
        <td class="short" v-if="toggle">{{ v.photo }}</td>
        <td class="short" v-if="toggle">{{ v.gift }}</td>
        <td class="short">{{ v.note }}</td>
        <td class="short">{{ v.date }}</td>
        <td class="short" v-if="toggle">{{ v.id }}</td>
        <td class="short">{{ v.owned }}</td>
        <!-- <td class="short">{{ v.ownedname }}</td> -->
        <td class="short" v-if="toggle">{{ v.role }}</td>
        <td class="short" v-if="toggle">{{ v.ctv }}</td>
        <td class="text-center" v-if="toggle">{{ v.status }}</td>
        <td class="text-center bg-danger text-white detail" @click="detail(v)" data-toggle="modal" data-target="#exampleModalLong">
          Chi tiết
        </td>
      </tr>
    </table>

    <!-- end  -->
  </div>

  <div class="d-flex justify-content-center">
    <button @click="back()" class="btn bg-primary text-white" type="button" name="button">
      back
    </button>
    <button class="btn bg-dark text-white" type="button" name="button">
      0
    </button>
    <button class="btn bg-dark text-white" type="button" name="button">
      {{ numberPage }}
    </button>
    <button class="btn bg-dark text-white" type="button" name="button">
      {{ maxPage }}
    </button>
    <button @click="next()" class="btn bg-danger text-white" type="button" name="button">
      next
    </button>
  </div>

  <!-- modal -->
  <!-- start -->
  <!-- Modal -->
  <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Chi tiết đơn hàng</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <h4>Tình trạng đơn</h4>
            <input type="text" v-model="detailOrder.ctv_id" />
          </div>

          <div>
            <h4>Mã vận đơn</h4>
            <input type="text" v-model="detailOrder.homebook" />
          </div>
          <div>
            <h4>Tên khách hàng</h4>
            <input type="text" v-model="detailOrder.name" />
          </div>
          <div>
            <h4>Địa chỉ</h4>
            <input type="text" v-model="detailOrder.address" />
          </div>
          <div>
            <h4>Số điện thoại 1</h4>
            <input type="text" v-model="detailOrder.phone_1" />
          </div>
          <div>
            <h4>Số điện thoại 2</h4>
            <input type="text" v-model="detailOrder.phone_2" />
          </div>
          <div>
            <h4>Facebook</h4>
            <input type="text" v-model="detailOrder.fb" />
          </div>
          <div>
            <h4>Link Facebook</h4>
            <input type="text" v-model="detailOrder.link" />
          </div>
          <div>
            <h4>Email</h4>
            <input type="text" v-model="detailOrder.email" />
          </div>
          <div>
            <h4>Mã sách in</h4>
            <input type="text" v-model="detailOrder.print" />
          </div>
          <div>
            <h4>Mã sách photo</h4>
            <input type="text" v-model="detailOrder.photo" />
          </div>
          <div>
            <h4>Mã sách tặng</h4>
            <input type="text" v-model="detailOrder.gift" />
          </div>
          <div>
            <h4>Tổng tiền</h4>
            <input type="text" v-model="detailOrder.note" />
          </div>
          <div>
            <h4>Ngày tạo</h4>
            <input type="text" v-model="detailOrder.date" disabled />
          </div>
          <div>
            <h4>Người tạo</h4>
            <input type="text" v-model="detailOrder.owned" disabled />
          </div>
          <div>
            <h4>Tình trạng</h4>
            <input type="text" v-model="detailOrder.status" />
          </div>
          <div>
            <h4>Thuộc</h4>
            <input type="text" v-model="detailOrder.ctv" disabled />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-danger" @click="deleted()" data-dismiss="modal">Xóa</button>
          <button type="button" class="btn btn-primary" @click="saved()" data-dismiss="modal">Lưu</button>
        </div>
      </div>
    </div>
  </div>
  <!-- end -->

  <Footer />
</div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  props: {},

  components: {
    Header,
    Footer
  },

  data() {
    return {
      detailOrder: {},
      allOrder: [],
      partOrder: [],
      toggle: false,
      choise: false,
      checkboxed: [],
      currentPage: 0,
      maxPage: 0,
      numberPage: 0
    };
  },

  methods: {
    next() {
      if (this.numberPage >= 0 && this.numberPage < this.maxPage) {
        this.currentPage += 50;
        this.partOrder = this.allOrder.slice(
          this.currentPage,
          this.currentPage + 50
        );
        this.numberPage++;
      }
    },

    back() {
      if (
        this.numberPage >= 0 &&
        this.numberPage <= this.maxPage &&
        this.currentPage >= 50
      ) {
        this.currentPage -= 50;
        this.partOrder = this.allOrder.slice(
          this.currentPage,
          this.currentPage + 50
        );
        this.numberPage--;
      }
    },

    detail(e) {
      this.detailOrder = e;
    },

    sent() {
      for (let i = 0; i < this.checkboxed.length; i++) {
        let e = this.checkboxed[i];
        let url =
          `https://docs.google.com/forms/d/e/1FAIpQLSfA0JJHSRVlaO7na8OG_lqphVZZJFKFcvxg9TWCqBmQ9RRTcA/viewform?entry.779323644=${e.ctv_id}&entry.1649387703=${e.name}&entry.1176072596=${e.address}&entry.405040969=${e.phone_1}&entry.1182482198=${e.phone_2}&entry.1608546377=${e.fb}&entry.133737553=${e.link}&entry.1709295728=${e.email}&entry.1548548508=${e.print}&entry.1435293787=${e.photo}&entry.1015435963=${e.gift}&entry.1004660290=${e.note}`;
        window.open(url, "_blank");
      }
      this.checkboxed = [];
    },

    wait() {
      this.partOrder = this.allOrder.filter(e => {
        return e.status == "no";
      });
    },

    done() {
      this.partOrder = this.allOrder.filter(e => {
        return e.status == "yes";
      });
    },

    approved() {
      for (let i = 0; i < this.checkboxed.length; i++) {
        // Update the "Name" of the first row to "Jack Doe"
        this.checkboxed[i].status = 'yes';
        axios.put(
          "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders/id/" +
          this.checkboxed[i].id, this.checkboxed[i]).then(res => {});
      }
      alert("Đã duyệt thành công");
      this.checkboxed = [];
    },

    deleted() {
      this.partOrder = this.partOrder.filter(e => {
        return e.id != this.detailOrder.id;
      })
      axios.delete("https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders/id/" + this.detailOrder.id).then(res => {
        // console.log(res);
      })
      this.checkboxed = [];
    },

    saved() {
      axios.put("https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders/id/" + this.detailOrder.id, this.detailOrder).then(res => {})
      this.checkboxed = [];
    }
  },

  beforeCreate() {
    axios
      .get(
        "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders"
      )
      .then(response => {
        this.allOrder = response.data.reverse();
        this.partOrder = this.allOrder.slice(0, 50);
        this.maxPage = Math.floor(this.allOrder.length / 50);
      });
  }
};
</script>

<style lang="css" scoped>
#exampleModalLong h4 {
  font-weight: bold;
  background: #ecf0f1;
  margin: 0;
  padding: .5rem 0 .5rem .5rem;
  border: 5px;
}

#exampleModalLong input{
  margin-bottom: 2rem;
  width: 100%;
  padding: .5rem 1rem;
  background: #2ecc71;
  border: none;
  border-bottom: 4px solid #27ae60;
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/AdminOrder.vue